export default {"src":"/_next/static/media/email.a2ec2347.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};